import React from "react";
import { Card } from "react-onsenui";
import { getSubstanceReagents } from "../../services/megamix";
import ReactionColorCircle from "../analyze/ReactionColorCircle";
import tlcData from '../../data/tlc.json'; // Import JSON z danymi TLC
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import * as XMLParser from 'react-xml-parser'; // Keep XML parser for parsing XML data


const styles = {
  roaDropdown: {
    // marginTop: "20px",
    // marginBottom: "20px",
  },
  dropdownContainer: {
    marginBottom: "20px",
    // marginTop: "35px",
    display: "flex",
    alignItems: "center",
  },
  dropdown: {
    flexGrow: 1,
    padding: "10px",
    border: "1px solid #ddd",
    borderRadius: "5px",
    fontSize: "16px",
    width: "200px",  // Adjust the width as per your requirement
    whiteSpace: "nowrap",  // Prevent text from wrapping
    overflow: "hidden",    // Hide the overflowing text
    textOverflow: "ellipsis"  // Add the ellipsis for truncated text
  
  },
  dropdownLabel: {
    marginRight: "10px",
    fontWeight: "bold",
    color: "#333",
  },
  toggleButton: {
    color: "blue",
    textDecoration: "underline",
    cursor: "pointer",
    marginBottom: "10px"
  },
    listElement: {
      margin: "10px 0"
    },
    listElementContent: {
      color: "gray",
      fontSize: "0.9em",
      paddingTop: "5px",
      paddingBottom: "15px"
    },
    colorStrip: {
      display: "flex",
      justifyContent: "space-between",
      color: "#fff",
      textShadow: "1px 1px 3px rgba(0,0,0,1)",
      fontWeight: "bold",
      padding: "3px 6px",
      borderRadius: "5px",
      marginBottom: "2px"
    },
    toggleIcon: {
      cursor: "pointer",
      marginLeft: "10px",
      fontSize: "24px",  // Adjust icon size
      verticalAlign: "middle"  // Vertical alignment
    },
    collapsibleContent: {
      overflow: "hidden",
      transition: "max-height 0.3s ease-out",
      maxHeight: 0 // Start with hidden content
    },
    collapsibleContentOpen: {
      maxHeight: "1500px" // Arbitrary large value to allow content to fully expand
    },
    chartImageContainer: {
      paddingTop: '30px',
      overflow: 'hidden', // Ensures that only the image gets clipped
      height: 'auto', 
    },
    chartStyle: {
      maxWidth: '100%',
      width: 'auto',
      height: 'auto',
      marginTop: '-60px', // Moves the image up by 50px to trim the top
      display: 'block', // Ensures the image behaves correctly as a block-level element  
    },
    
  };

  
export default class SubstanceMegamix extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isListVisible: false,
      isChartVisible: false,   // For chart toggle
      isReagentsVisible: false, // For reagents toggle
      isPhotosVisible: false,   // For photos toggle
      isVideosVisible: false,   // For videos toggle
      substances: [],
      knownSubstance: '',
      knownHeight: '',
      unconfirmedSubstance: '',
      result: null,
      similarSubstances: [],
      showMore: false,
      showSimilarSubstances: false, // Toggle for similar substances
      showLearnMore: false, // Toggle for the "Click here to learn more"
      displayedSubstances: 30,
      isTlcVisible: false,  // Add this line for TLC visibility
      images: [], // New state to hold the images for the carousel

    };
  }

  componentDidMount() {
    // Load substance names from tlc.json
    const substanceNames = Object.keys(tlcData);
    this.setState({ substances: substanceNames });
  
    // Add this line to fetch images
    this.fetchImagesFromXml();
  }

  // Toggle visibility functions
  toggleListVisibility = () => {
    this.setState((prevState) => ({
      isListVisible: !prevState.isListVisible
    }));
  };

  toggleTlcVisibility = () => {
    this.setState((prevState) => ({
      isTlcVisible: !prevState.isTlcVisible
    }));
  };

  toggleChartVisibility = () => {
    this.setState((prevState) => ({
      isChartVisible: !prevState.isChartVisible
    }));
  };
  
  toggleReagentsVisibility = () => {
    this.setState((prevState) => ({
      isReagentsVisible: !prevState.isReagentsVisible
    }));
  };
  
  togglePhotosVisibility = () => {
    this.setState((prevState) => ({
      isPhotosVisible: !prevState.isPhotosVisible
    }));
  };
  
  toggleVideosVisibility = () => {
    this.setState((prevState) => ({
      isVideosVisible: !prevState.isVideosVisible
    }));
  };
  

  // Calculate the expected result based on the selected substances
  calculateDynamicResult = () => {
    const { knownSubstance, knownHeight, unconfirmedSubstance } = this.state;
    if (!knownSubstance || !unconfirmedSubstance || isNaN(knownHeight) || knownHeight === '') {
      this.setState({ result: null, similarSubstances: [] });
      return;
    }

    const knownCaffeineRatio = parseFloat(tlcData[knownSubstance]["Caffeine ratio avarage"].replace(",", "."));
    const unconfirmedCaffeineRatio = parseFloat(tlcData[unconfirmedSubstance]["Caffeine ratio avarage"].replace(",", "."));

    if (isNaN(knownCaffeineRatio) || isNaN(unconfirmedCaffeineRatio)) {
      this.setState({ result: "Invalid caffeine ratios for selected substances.", similarSubstances: [] });
      return;
    }

    // Corrected formula: Expected Height = Known Height * (Caffeine Ratio of Unconfirmed Substance / Caffeine Ratio of Known Substance)
    const resultValue = knownHeight * (unconfirmedCaffeineRatio / knownCaffeineRatio);
    this.setState({ result: resultValue.toFixed(2) + " cm" }, this.calculateSimilarSubstances);
  };

  calculateSimilarSubstances = () => {
    const { knownHeight, result, substances, knownSubstance } = this.state;
    const targetResult = parseFloat(result);

    const similarSubstances = substances
      .filter(substance => {
        const caffeineRatio = parseFloat(tlcData[substance]["Caffeine ratio avarage"].replace(",", "."));
        const knownCaffeineRatio = parseFloat(tlcData[knownSubstance]["Caffeine ratio avarage"].replace(",", "."));
        const calculatedHeight = knownHeight * (caffeineRatio / knownCaffeineRatio);
        const difference = Math.abs(calculatedHeight - targetResult);
        return difference <= 0.4;
      })
      .map(substance => {
        const caffeineRatio = parseFloat(tlcData[substance]["Caffeine ratio avarage"].replace(",", "."));
        const knownCaffeineRatio = parseFloat(tlcData[knownSubstance]["Caffeine ratio avarage"].replace(",", "."));
        const calculatedHeight = knownHeight * (caffeineRatio / knownCaffeineRatio);
        return { substance, calculatedHeight: calculatedHeight.toFixed(2), difference: (calculatedHeight - targetResult).toFixed(2) };
      })
      .sort((a, b) => Math.abs(a.difference) - Math.abs(b.difference));

    this.setState({ similarSubstances });
  };

  // TLC Calculator Component (refactored)
  renderTlcCalculator = () => {
    const { substances, knownSubstance, unconfirmedSubstance, knownHeight, result, similarSubstances } = this.state;

    return (
      <Card className="tlc-calculator-card" style={{ padding: "0px 20px 1px", boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)' }}>
        <h2 onClick={this.toggleTlcVisibility} style={{ cursor: 'pointer', display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
          TLC Calculator
          <i
            className={`zmdi ${this.state.isTlcVisible ? "zmdi-chevron-up" : "zmdi-chevron-down"}`}
            style={styles.toggleIcon}
          ></i>
        </h2>
        {this.state.isTlcVisible && (
          <div style={{marginBottom: "20px"}}>
            <p>
              Use a confirmed substance (e.g. caffeine) to identify an unconfirmed substance detected with a TLC test kit using the primary testing liquid.
              <i 
                className="zmdi zmdi-info-outline" 
                style={{ marginLeft: '10px', cursor: 'pointer' }} 
                onClick={this.handleInfoClick}  // Kliknięcie ikony wywołuje handleInfoClick
              ></i>
            </p>

            {/* Confirmed substance dropdown */}
            <div style={styles.roaDropdown}>
              <div style={styles.dropdownContainer}>
                <label style={styles.dropdownLabel}>Confirmed substance:</label>
                <select
                  style={styles.dropdown}
                  value={knownSubstance}
                  onChange={(e) => this.setState({ knownSubstance: e.target.value }, this.calculateDynamicResult)}
                >
                  <option value="">Search...</option>
                  {substances.map((substance, index) => (
                    <option key={index} value={substance}>
                      {substance}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* Unconfirmed substance dropdown */}
            <div style={styles.roaDropdown}>
              <div style={styles.dropdownContainer}>
                <label style={styles.dropdownLabel}>Unconfirmed substance:</label>
                <select
                  style={styles.dropdown}
                  value={unconfirmedSubstance}
                  onChange={(e) => this.setState({ unconfirmedSubstance: e.target.value }, this.calculateDynamicResult)}
                >
                  <option value="">Search...</option>
                  {substances.map((substance, index) => (
                    <option key={index} value={substance}>
                      {substance}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* Confirmed height input */}
            <div>
              <label>Confirmed height:</label>
              <input
                type="number"
                id="knownHeightInput"
                className="inputField"
                value={knownHeight}
                onChange={(e) => this.setState({ knownHeight: e.target.value }, this.calculateDynamicResult)}
              />{' '}
              cm
              <br />
              <div>
                <span>Expected height: {result ? result : ''} +- 0.4 cm</span>
              </div>
            </div>

            {/* Similar substances */}
            {similarSubstances.length > 0 && (
              <div>
                <ul>
                  {similarSubstances.map((item, index) => (
                    <li key={index} style={{listStyle: "inside"}}>
                      {/* {item.substance}: {item.calculatedHeight} cm ({item.difference} cm) */}
                      {item.substance}: {item.calculatedHeight} cm
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        )}
      </Card>
    );
  };

  renderReagentReaction(reagent, reaction, index) {
    const result = Object.assign(reaction, { reagent: reagent });

    if (!reaction.colors || reaction.colors.length === 0) {
      const url = `${window.location.origin}${window.location.pathname}?analyze=${reagent.id}n`;

      return (
        <a href={url} key={index} style={{ textDecoration: 'none', color: 'inherit' }}>
          <ReactionColorCircle result={result} />
        </a>
      );
    }

    const finalColor = reaction.colors[reaction.colors.length - 1];
    const colorMap = {
      2: 'b',
      17: 'w',
      8: 'g',
      20: 'r',
      14: 'o',
      11: 'y',
      5: 'l',
      26: 'u',
      23: 'p',
    };

    const simpleColorLetter = colorMap[finalColor.simpleColorId];

    if (!simpleColorLetter) {
      return <ReactionColorCircle result={result} key={index} />;
    }

    const url = `${window.location.origin}${window.location.pathname}?analyze=${reagent.id}${simpleColorLetter}`;

    return (
      <a href={url} key={index} style={{ textDecoration: 'none', color: 'inherit' }}>
        <ReactionColorCircle result={result} />
      </a>
    );
  }

  normalizeSubstanceName(name) {
    return name.toLowerCase().replace(/[^a-z0-9]/g, '');
  }

  fetchImagesFromXml = async () => {
    try {
      const response = await fetch('https://protestkit.eu/wp-content/reaction-photos/reactions.xml');
      const text = await response.text();
      const xml = new XMLParser().parseFromString(text); // Parse XML string
      
      const { commonName } = this.props.substance;
  
      // Normalize commonName to lowercase and trim whitespace
      const normalizedCommonName = this.normalizeSubstanceName(commonName);
  
      // Filter images by category
      let filteredItems = xml.getElementsByTagName('item').filter(item => {
        const category = item.getElementsByTagName('category')[0]?.value?.toLowerCase().trim();
        return category && this.normalizeSubstanceName(category).includes(normalizedCommonName);
      });
  
      // If no results in category, filter by title
      if (filteredItems.length === 0) {
        filteredItems = xml.getElementsByTagName('item').filter(item => {
          const title = item.getElementsByTagName('title')[0]?.value?.toLowerCase().trim();
          return title && this.normalizeSubstanceName(title).includes(normalizedCommonName);
        });
      }
  
      const images = filteredItems.map(item => ({
        image: item.getElementsByTagName('image')[0].value,
        description: item.getElementsByTagName('description')[0].value,
      }));
  
      if (images.length === 0) {
        console.warn('No images found for commonName:', commonName);
      }
  
      this.setState({ images });
    } catch (error) {
      console.error('Error fetching and parsing XML:', error);
    }
  };
  
  
  renderCarouselItem = ({ item }) => (
    <div style={{ padding: '10px', textAlign: 'center' }}>
      <img
        src={item.image}
        alt="carousel item"
        style={{
          width: '100%',
          height: '300px', // You can adjust this value
          objectFit: 'cover', // Ensures the image covers the area while maintaining aspect ratio
          borderRadius: '10px',
          maxWidth: '100%',
          maxHeight: '300px', // Same as height to keep the image within bounds
        }}
      />
      <p style={{ marginTop: '10px', fontSize: '14px', color: '#333', textAlign: 'center' }}>
        {item.description}
      </p>
    </div>
  );
  
  

  // Dodaj funkcję obsługującą kliknięcie na ikonę
handleInfoClick = () => {
  alert('TLC test can help estimate both potency and purity. Thin Layer Chromatography (TLC) is a semi-quantitative and qualitative analysis method.'); 
};

handleReagentsInfoClick = () => {
  alert('Reagents tests (for example Marquis or Mq) are chemicals which change color on contact with a substance, allowing for identification. Click reagent name to learn more about it.');
};

  renderReagent(reagent) {
    return (
      <div key={reagent.reagent.id}>
        {reagent.reactions.map((reaction, index) =>
          this.renderReagentReaction(reagent.reagent, reaction, index)
        )}
      </div>
    );
  }

  renderReagents() {
    const { substance } = this.props;
    const reagents = getSubstanceReagents(substance.id);
    return <div className="testdrugs-substance-reagents-list" style={{marginTop: "-15px"}}>{reagents.map(this.renderReagent.bind(this))}</div>;
  }

  render() {
    const { name, commonName } = this.props.substance;
    const { isListVisible, images } = this.state;
  
    // Check conditions for each chart
    const shouldDisplayMdmaChart = /MD|2C|amphetamine/i.test(name) || /MD|2C|amphetamine/i.test(commonName);
    const shouldDisplayCocaineChart = /cocaine/i.test(name) || /cocaine/i.test(commonName);
    const shouldDisplayLsdChart = /lsd/i.test(name) || /lsd/i.test(commonName);
    const shouldDisplayDmtChart = /dmt/i.test(name) || /dmt/i.test(commonName);
    const shouldDisplayKetamineChart = /ketamine/i.test(name) || /ketamine/i.test(commonName);
    const shouldDisplayCannabisChart = /canna|cbd/i.test(name) || /canna|cbd/i.test(commonName);
    const shouldDisplaySyntheticChart = /mmc|cmc|tylone|pv|php|cec|hex|drone/i.test(name) || /mmc|cmc|tylone|pv|php|cec|hex|drone/i.test(commonName);
    const shouldDisplayOpioidChart = /morphine|heroin|codeine|codone|dsmt/i.test(name) || /morphine|heroin|codeine|codone|dsmt/i.test(commonName);
    const shouldDisplayBenzoChart = /zepam|zolam/i.test(name) || /zepam|zolam/i.test(commonName);
  
    const shouldDisplayAnyChart = shouldDisplayMdmaChart || shouldDisplayCocaineChart || shouldDisplayLsdChart || 
                                  shouldDisplayDmtChart || shouldDisplayKetamineChart || shouldDisplayCannabisChart || 
                                  shouldDisplaySyntheticChart || shouldDisplayOpioidChart || shouldDisplayBenzoChart;
  
    // Auto-open the reactions if no chart should be displayed
    const autoOpenReagents = !shouldDisplayAnyChart;

                                  return (
                                    <>
                                      {/* Test Results Card */}
                                      <Card className="simplified-list" style={{ marginBottom: "30px", padding: "0px 20px", boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)' }}>
                                        <h2 onClick={this.toggleListVisibility} style={{ cursor: 'pointer', display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
                                          {commonName} Reagent Test Results
                                          <i className={`zmdi ${isListVisible ? "zmdi-chevron-up" : "zmdi-chevron-down"}`} style={styles.toggleIcon} ></i>
                                        </h2>
                                        <div style={{ ...styles.collapsibleContent, ...(isListVisible ? styles.collapsibleContentOpen : {}) }}>
                                          {isListVisible && (
                                            <>
                                              {/* Toggle for Charts */}
                                              {shouldDisplayAnyChart && (
        <p onClick={this.toggleChartVisibility} style={{ cursor: 'pointer', display: "flex", alignItems: "center", marginBottom: "15px", justifyContent: "space-between" }}>
  <div style={{ display: "flex", alignItems: "center" }}>
    <i className={`zmdi ${this.state.isChartVisible ? "zmdi-chevron-up" : "zmdi-chevron-down"}`} style={styles.toggleIcon}></i>
    <b style={{ textAlign: "left", marginLeft: '10px' }}>Recommended chart</b>
  </div>
</p>)}

        <div style={{ ...styles.collapsibleContent, ...(this.state.isChartVisible ? styles.collapsibleContentOpen : {}) }}>
          {this.state.isChartVisible && (
            <>

            <div style={{ marginBottom: '5px'}} >
                  Click the chart below for full size.
                </div>
              

                {/* Conditionally render the appropriate charts */}
                {shouldDisplayMdmaChart && (
                  <div style={{ marginBottom: '20px', textAlign: 'center' }}>
                    <div style={styles.chartImageContainer}>
                    <a href="https://protestkit.eu/mdmachart" target="_blank" rel="noopener noreferrer">
                      <img
                        src="https://protestkit.eu/mdmachart"
                        alt="MDMA Chart"
                        style={styles.chartStyle}                      />
                    </a></div>
                  </div>
                )}
  
                {shouldDisplayCocaineChart && (
                  <div style={{ marginBottom: '20px', textAlign: 'center' }}>
                    <a href="https://protestkit.eu/cocachart" target="_blank" rel="noopener noreferrer">
                    <div style={styles.chartImageContainer}>
                    <img
                        src="https://protestkit.eu/cocachart"
                        alt="Cocaine Chart"
                        style={styles.chartStyle}
                      /></div>
                    </a>
                  </div>
                )}
  
                {shouldDisplayLsdChart && (
                  <div style={{ marginBottom: '20px', textAlign: 'center' }}>
                    <a href="https://protestkit.eu/lsdchart" target="_blank" rel="noopener noreferrer">
                    <div style={styles.chartImageContainer}>
                    <img
                        src="https://protestkit.eu/lsdchart"
                        alt="LSD Chart"
                        style={styles.chartStyle}
                      /></div>
                    </a>
                  </div>
                )}
  
                {shouldDisplayDmtChart && (
                  <div style={{ marginBottom: '20px', textAlign: 'center' }}>
                    <a href="https://protestkit.eu/dmtchart" target="_blank" rel="noopener noreferrer">
                    <div style={styles.chartImageContainer}>
                    <img
                        src="https://protestkit.eu/dmtchart"
                        alt="DMT Chart"
                        style={styles.chartStyle}
                      /></div>
                    </a>
                  </div>
                )}
  
                {shouldDisplayKetamineChart && (
                  <div style={{ marginBottom: '20px', textAlign: 'center' }}>
                    <a href="https://protestkit.eu/ketachart" target="_blank" rel="noopener noreferrer">
                    <div style={styles.chartImageContainer}>
                    <img
                        src="https://protestkit.eu/ketachart"
                        alt="Ketamine Chart"
                        style={styles.chartStyle}
                      /></div>
                    </a>
                  </div>
                )}
  
                {shouldDisplayCannabisChart && (
                  <div style={{ marginBottom: '20px', textAlign: 'center' }}>
                    <a href="https://protestkit.eu/cannachart" target="_blank" rel="noopener noreferrer">
                    <div style={styles.chartImageContainer}>
                    <img
                        src="https://protestkit.eu/cannachart"
                        alt="Cannabis Chart"
                        style={styles.chartStyle}
                      /></div>
                    </a>
                  </div>
                )}
  
                {shouldDisplaySyntheticChart && (
                  <div style={{ marginBottom: '20px', textAlign: 'center' }}>
                    <a href="https://protestkit.eu/cathchart" target="_blank" rel="noopener noreferrer">
                    <div style={styles.chartImageContainer}>
                    <img
                        src="https://protestkit.eu/cathchart"
                        alt="Synthetic Stimulants Chart"
                        style={styles.chartStyle}
                      /></div>
                    </a>
                  </div>
                )}
  
                {shouldDisplayOpioidChart && (
                  <div style={{ marginBottom: '20px', textAlign: 'center' }}>
                    <a href="https://protestkit.eu/opiochart" target="_blank" rel="noopener noreferrer">
                    <div style={styles.chartImageContainer}>
                    <img
                        src="https://protestkit.eu/opiochart"
                        alt="Opioid Chart"
                        style={styles.chartStyle}
                      /></div>
                    </a>
                  </div>
                )}
  
                {shouldDisplayBenzoChart && (
                  <div style={{ marginBottom: '20px', textAlign: 'center' }}>
                    <a href="https://protestkit.eu/benzochart" target="_blank" rel="noopener noreferrer">
                    <div style={styles.chartImageContainer}>
                    <img
                        src="https://protestkit.eu/benzochart"
                        alt="Benzo Chart"
                        style={styles.chartStyle}
                      /></div>
                    </a>
                  </div>
                )}
  

              </>
            )}
          </div>

{/* Reagents section */}
<div style={{ marginBottom: '0px' }}>
  {autoOpenReagents ? (
    // If no chart, auto-open the reagents and don't show the header
    <>
      <div style={{ marginBottom: '20px', cursor: 'pointer' }} onClick={this.handleReagentsInfoClick}>
        Click number count to view substances with similar results
        <i className="zmdi zmdi-info-outline" style={{ marginLeft: '10px', cursor: 'pointer' }}></i>
      </div>
      <div style={styles.listElement}>
        <div style={styles.listElementContent}>
          {this.renderReagents()}
        </div>
      </div>
    </>
  ) : (
    // If chart is displayed, show the usual toggle for reagents
    <>
      <p onClick={this.toggleReagentsVisibility} style={{ cursor: 'pointer', display: "flex", alignItems: "center", marginBottom: "15px", justifyContent: "space-between" }}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <i className={`zmdi ${this.state.isReagentsVisible ? "zmdi-chevron-up" : "zmdi-chevron-down"}`} style={styles.toggleIcon}></i>
          <b style={{ textAlign: "left", marginLeft: '10px' }}>All {commonName} reactions</b>
        </div>
      </p>
      <div style={{ ...styles.collapsibleContent, ...(this.state.isReagentsVisible ? styles.collapsibleContentOpen : {}) }}>
        {this.state.isReagentsVisible && (
          <>
            <div style={{ marginBottom: '20px', cursor: 'pointer' }} onClick={this.handleReagentsInfoClick}>
              Click number count to view substances with similar results
              <i className="zmdi zmdi-info-outline" style={{ marginLeft: '10px', cursor: 'pointer' }}></i>
            </div>
            <div style={styles.listElement}>
              <div style={styles.listElementContent}>
                {this.renderReagents()}
              </div>
            </div>
          </>
        )}
      </div>
    </>
  )}
</div>


             {/* Toggle for Photos */}
             {images.length > 0 && (
                <p onClick={this.togglePhotosVisibility} style={{ cursor: 'pointer', display: "flex", alignItems: "center", marginBottom: "15px", justifyContent: "space-between" }}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <i className={`zmdi ${this.state.isPhotosVisible ? "zmdi-chevron-up" : "zmdi-chevron-down"}`} style={styles.toggleIcon}></i>
                    <b style={{ textAlign: "left", marginLeft: '10px' }}>Submitted photos</b>
                  </div>
                </p>
              )}

              {/* Photos content */}


        <div style={{ ...styles.collapsibleContent, ...(this.state.isPhotosVisible ? styles.collapsibleContentOpen : {}) }}>
        {this.state.isPhotosVisible && (
  <div className="carousel-container">
    {this.state.images.length > 0 ? (
      <Carousel
  showThumbs={true}           // Hide thumbnail images
  showIndicators={false}       // Hide navigation dots
  showStatus={true}           // Hide status (1/3, 2/3, etc.)
  dynamicHeight={true}         // Adjust carousel height dynamically based on the image
  autoPlay={false}              // Optional: Auto-play the carousel
  infiniteLoop={true}          // Optional: Loop through images infinitely
  stopOnHover={true}           // Optional: Stop auto-play on hover
>
{this.state.images.map((item, index) => (
    <div key={index}>
      <img 
        src={item.image} 
        alt={`Carousel item ${index}`} 
        style={{ 
          width: '100%', 
          height: 'auto', 
          maxHeight: '80vh',  // Limit image height to avoid pushing thumbnails off-screen
          objectFit: 'contain' // Ensure the image fits within the area without cropping
        }} 
      />
      <p className="legend">{item.description}</p>
    </div>
  ))}
</Carousel>


    ) : (
      <p>No photos available for this substance.</p>
    )}
  </div>
)}



        </div>

        {/* Toggle for Videos */}
        <p onClick={this.toggleVideosVisibility} style={{ cursor: 'pointer', display: "flex", alignItems: "center", marginBottom: "15px", justifyContent: "space-between" }}>
  <div style={{ display: "flex", alignItems: "center" }}>
    <i className={`zmdi ${this.state.isVideosVisible ? "zmdi-chevron-up" : "zmdi-chevron-down"}`} style={styles.toggleIcon}></i>
    <b style={{ textAlign: "left", marginLeft: '10px' }}>Reaction videos</b>
  </div>
</p>
        <div style={{ ...styles.collapsibleContent, ...(this.state.isVideosVisible ? styles.collapsibleContentOpen : {}) }}>
          {this.state.isVideosVisible && (
            <div>
              <p>Selected videos are available in Results/Videos site menu section</p>
            </div>
          )}
        </div>
      </>
    )}
  </div>
</Card>

        {/* TLC Calculator Card */}
        {this.renderTlcCalculator()}
      </>
    );
  }
  

  
}